import {useEffect, useMemo, useRef} from "react";

import {RequestState} from "@pg-mono/request-state";

import {IAmplitudeItemListContext} from "../../../tracking/amplitude/get_amplitude_view_item_event_properties";
import {trackAmplitudeOfferViewItemList} from "../../../tracking/amplitude/track_amplitude_offer_view_item_list";
import {IOfferListOffer} from "../../types/IOfferListOffer";
import {isOfferListingRouteQuerySyncedWithLatestQuery} from "../helpers/is_offer_listing_route_query_synced_with_latest_query";
import {IOfferListLatestQuery} from "../types/IOfferListLatestQuery";

type OfferListingRouteQuery = Record<string, string | string[] | null | boolean | undefined>;

interface IUseOfferListingAmplitudeViewItemListTrackingParams {
    offers: IOfferListOffer[];
    amplitudeItemListContext: IAmplitudeItemListContext;
    routeQuery: OfferListingRouteQuery;
    latestQuery: IOfferListLatestQuery;
    requestState: RequestState;
    isInitialOfferListFetchDone: boolean;
}

const getAmplitudeViewItemListContextKey = (itemListContext: IAmplitudeItemListContext, offerIds: string[]) =>
    `${itemListContext.itemListId ?? ""}|${JSON.stringify(itemListContext.itemListName)}|${offerIds.join(",")}`;

// DS-A-32
export const useOfferListingAmplitudeViewItemListTracking = (params: IUseOfferListingAmplitudeViewItemListTrackingParams) => {
    const {offers, amplitudeItemListContext, routeQuery, latestQuery, requestState, isInitialOfferListFetchDone} = params;

    const prevTrackedContextKeyRef = useRef<string | null>(null);

    const offerIds = useMemo(() => offers.map(({id}) => id.toString()), [offers]);
    const isListingQuerySyncedWithRoute = isOfferListingRouteQuerySyncedWithLatestQuery(routeQuery, latestQuery);

    useEffect(() => {
        if (!isInitialOfferListFetchDone) {
            return;
        }

        if (requestState === RequestState.Waiting) {
            prevTrackedContextKeyRef.current = null;
            return;
        }

        if (requestState !== RequestState.Success || !isListingQuerySyncedWithRoute) {
            return;
        }

        const contextKey = getAmplitudeViewItemListContextKey(amplitudeItemListContext, offerIds);

        if (prevTrackedContextKeyRef.current === contextKey) {
            return;
        }

        prevTrackedContextKeyRef.current = contextKey;

        trackAmplitudeOfferViewItemList({
            offers,
            itemListId: amplitudeItemListContext.itemListId,
            itemListName: amplitudeItemListContext.itemListName ?? ""
        });
    }, [
        isInitialOfferListFetchDone,
        requestState,
        isListingQuerySyncedWithRoute,
        offerIds.join(","),
        amplitudeItemListContext.itemListId,
        amplitudeItemListContext.itemListName,
        offers
    ]);
};
import {useEffect, useMemo, useRef} from "react";

import {RequestState} from "@pg-mono/request-state";

import {IAmplitudeItemListContext} from "../../../tracking/amplitude/get_amplitude_view_item_event_properties";
import {trackAmplitudeOfferViewItemList} from "../../../tracking/amplitude/track_amplitude_offer_view_item_list";
import {IOfferListOffer} from "../../types/IOfferListOffer";
import {isOfferListingRouteQuerySyncedWithLatestQuery} from "../helpers/is_offer_listing_route_query_synced_with_latest_query";
import {IOfferListLatestQuery} from "../types/IOfferListLatestQuery";

type OfferListingRouteQuery = Record<string, string | string[] | null | boolean | undefined>;

interface IUseOfferListingAmplitudeViewItemListTrackingParams {
    offers: IOfferListOffer[];
    amplitudeItemListContext: IAmplitudeItemListContext;
    routeQuery: OfferListingRouteQuery;
    latestQuery: IOfferListLatestQuery;
    requestState: RequestState;
    isInitialOfferListFetchDone: boolean;
}

const getAmplitudeViewItemListContextKey = (itemListContext: IAmplitudeItemListContext, offerIds: string[]) =>
    `${itemListContext.itemListId ?? ""}|${JSON.stringify(itemListContext.itemListName)}|${offerIds.join(",")}`;

// DS-A-32
export const useOfferListingAmplitudeViewItemListTracking = (params: IUseOfferListingAmplitudeViewItemListTrackingParams) => {
    const {offers, amplitudeItemListContext, routeQuery, latestQuery, requestState, isInitialOfferListFetchDone} = params;

    const prevTrackedContextKeyRef = useRef<string | null>(null);

    const offerIds = useMemo(() => offers.map(({id}) => id.toString()), [offers]);
    const isListingQuerySyncedWithRoute = isOfferListingRouteQuerySyncedWithLatestQuery(routeQuery, latestQuery);

    useEffect(() => {
        if (!isInitialOfferListFetchDone) {
            return;
        }

        if (requestState === RequestState.Waiting) {
            prevTrackedContextKeyRef.current = null;
            return;
        }

        if (requestState !== RequestState.Success || !isListingQuerySyncedWithRoute) {
            return;
        }

        const contextKey = getAmplitudeViewItemListContextKey(amplitudeItemListContext, offerIds);

        if (prevTrackedContextKeyRef.current === contextKey) {
            return;
        }

        prevTrackedContextKeyRef.current = contextKey;

        trackAmplitudeOfferViewItemList({
            offers,
            itemListId: amplitudeItemListContext.itemListId,
            itemListName: amplitudeItemListContext.itemListName ?? ""
        });
    }, [
        isInitialOfferListFetchDone,
        requestState,
        isListingQuerySyncedWithRoute,
        offerIds.join(","),
        amplitudeItemListContext.itemListId,
        amplitudeItemListContext.itemListName,
        offers
    ]);
};
